module.exports = __webpack_public_path__ + "img/news_2.36b24e44.jpg";